/* 处理时间 */
import moment from "moment"
export function time_format_fash_new (time) {
    // 时间今天。昨天。当年：08月01日.非当年 22年01月31
    if (time) {
            let _now = moment(Date.now()).format("YYYY-MM-DD");
            let year = moment(time).format('YYYY')
            let _now_year = moment(_now).format('YYYY')
            var yesterday = moment(time).format("YYYY-MM-DD");
            var strDayName = "";
            var lessDay = moment(_now).diff(moment(yesterday), 'days');
            switch(lessDay) {
                case 0: strDayName = '今天'; break;
                case 1: strDayName = '昨天'; break;
                default: 
                    if (year != _now_year) {
                        strDayName = moment(time).format('YYYY/MM/DD')
                    } else if (year == _now_year) {
                        strDayName = moment(time).format('MM/DD')
                    }
                    break
            }
            return strDayName
            
    }
}
export function time_format_new (time) {
    // console.log(time)
    let result = null;
    // 时间当天，xx小时前。一周内，xx天前。一个月内，xx周前。一年内，xx月前。一年外：xx年前
    if (time) {
        let now_time = new Date().getTime()
        let time_diff = now_time - time
        let minutes = 1000 * 60;
        let hours = minutes * 60;
        let _now = moment(Date.now()).format("YYYY-MM-DD")
        let year = moment(time).format('YYYY')
        let _now_year = moment(_now).format('YYYY')
        let month = moment(time).format('MM')
        let _now_month = moment(_now).format('MM')
        let day = moment(time).format('DD')
        let _now_day = moment(_now).format('DD')
        if (year != _now_year) {
            result = `${year}年${month >= 10 ? month: `${month}`}月${day >= 10 ? day : `${day}`}日`
        } else if (year == _now_year && month == _now_month && day == _now_day) {
            if (time_diff / hours >=2) {
                result = moment(time).format('HH:mm');
            } else if (time_diff / hours >=1) {
                result = parseInt(time_diff / hours) + "小时前";
            } else if (time_diff / minutes >= 1) {
                result = parseInt(time_diff / minutes) + "分钟前";
            } else {
                result = "刚刚";
            }
            
        }else if (year == _now_year) {
            result = `${month >= 10 ? month: `${month}`}月${day >= 10 ? day : `${day}`}日`
            result = month + '月' + day + '日'
        }
        return result

    }
}
export function time_format(addTime) {
    if (addTime) {
        let _now = Date.now();
        let hour = new Date(addTime).getHours()
        let minute = new Date(addTime).getMinutes()
        let day = new Date(addTime).getDate()
        let h = new Date(addTime).getHours()
        let m = new Date(addTime).getMinutes()
        let month = new Date(addTime).getMonth() + 1
        let year = new Date(addTime).getFullYear()
        let _now_day = new Date(_now).getDate()
        let _now_month = new Date(_now).getMonth() + 1
        let _now_year = new Date(_now).getFullYear()
        if (_now_year === year && _now_month === month && day === _now_day) {
            return `${hour >= 10 ? hour: `0${hour}`}: ${minute >= 10 ? minute: `0${minute}`}`
        } else if (_now_year == year){
            return `${month >= 10 ? month: `0${month}`}月${day >= 10 ? day: `0${day}`}日 ${h >= 10 ? h : "0" + h}:${m >=10 ? m:"0"+m}`
        } else {
            return `${year}年${month >= 10 ? month: `0${month}`}月`
        }
    }
}
export function timeFormat(addTime) {
    if (addTime) {
        let _now = Date.now();
        let day = new Date(addTime).getDate()
        let month = new Date(addTime).getMonth() + 1
        let year = new Date(addTime).getFullYear()
        let _now_day = new Date(_now).getDate()
        let _now_month = new Date(_now).getMonth() + 1
        let _now_year = new Date(_now).getFullYear()
        if (_now_year == year){
            return `${month >= 10 ? month: `0${month}`}月${day >= 10 ? day: `0${day}`}日`
        } else {
            return `${year}年${month >= 10 ? month: `0${month}`}月`
        }
    }
}
export function getTime(time) {
    const year = new Date(time).getFullYear()
    const month = new Date(time).getMonth() + 1
    const day = new Date(time).getDate()
    return `${year}-${month>=10?month:`0${month}`}-${day>=10?day:`0${day}`}`
}
export function secToTime(s) {
    let t = ''
        var hour = Math.floor(s/3600)
        var min = Math.floor(s/60) % 60
        var sec = s % 60
        if(hour) {
            if(hour < 10) {
                t = '0'+ hour + ":"
            } else {
                t = hour + ":"
            }
        }
        if(min < 10){
            t += "0"
          }
        t += min + ":"
        if(sec < 10){
            t += "0"
        }
          t += sec.toFixed(0)

    return t
}
